export default function persistStateFilter({ type }) {
  if (type === 'SET_PASSWORD') {
    return false
  }

  return true
}
